Vue.filter("propHasIdOne", function (data) {
  if (!data) {
      return false;
  }
  if (data.filter(function (e) { return e.property.id == 1; }).length > 0) {
      return true;
  }
  return false;
});
